import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { ErrorText, FindLoad, FindSuccessItem, Images, useGlobalStyles, useModal } from 'utils';
import {
  AddModalButton,
  CustomNumericFormat, Loader, MinLoader,
  NoYet,
  PriceRow,
  TextRow,
  ToastScreen,
  ValidationInput,
} from 'components';
import { carrierActions, collectionActions, loadActions } from 'store';
import { COLLECT_LOAD_ACTION_TYPE } from '../constants';
import { CollectRow } from './collectRow';
import { LoadService } from '../../../../fragments/factoredLoads/load.service';
import { inputsStyle } from '../../../../components/inputs/styles';
import { loadStatusEnum } from '../../../loads';
import { useForm } from 'react-hook-form';

const LOAD_ACTION_TYPE = 'GET_LOADS_BY_STATUS';
const LOAD_CARRIER_ACTION_TYPE = 'GET_CARRIER_BY_ID';
export const CollectLoads = ({ item }) => {
  const { loadsList, carrier } = useSelector((state) => ({
    loadsList: state.loads.loadsList,
    carrier: state.carriers.carrierById,
  }));
  const classes = inputsStyle();
  const globalStyles = useGlobalStyles();
  const dispatch = useDispatch();
  const { close } = useModal();
  const loadList = FindLoad(LOAD_ACTION_TYPE);
  const loader = FindLoad(COLLECT_LOAD_ACTION_TYPE);
  const success = FindSuccessItem(COLLECT_LOAD_ACTION_TYPE);
  const [error, setError] = useState('');
  const [dept, setDept] = useState(carrier?.debt);
  const [selectedId, setSelectedId] = useState(null);
  const ref = useRef();
  const [loadId, setLoadId] = useState(null);
  const [saveId, setSaveId] = useState(null);
  const carrierLoad = FindLoad(LOAD_CARRIER_ACTION_TYPE);
  const { handleSubmit} = useForm({ mode: "onSubmit" });

  const getSingleCarrier = (load) => {
    dispatch(carrierActions.getCarrierById(item?.id, load));
  };

  const getLoads = (load, search) => {
    const params = {
      statuses: ['PROCESSING', loadStatusEnum.PENDING_FLOAT],
      carrier: item?.id,
      skip: 0,
      limit: 100,
    };

    if (search) {
      delete params?.payableStatuses;
      params.searchKey = 'LOAD_DISPLAY_ID';
      params.searchValue = loadId;
    } else {
      params.payableStatuses = ['NOTPAYABLE', 'PAYABLE', 'PMT_VERIFICATION'];
      delete params?.searchKey;
      delete params?.searchValue;
    }
    dispatch(loadActions.getLoadsByStatus(params, load));
  };

  useEffect(() => {
    if (loadsList?.loads?.length) {
      const params = loadsList.loads.map(item => {
        // const balance = LoadService.getPayableBalance(item?.payable);
        if (item?.payable?.balance > 0) {
          return {
            loadId: item?.id,
            loadDisplayId: item?.displayId,
            amount: item?.payable?.balance,
            comment: item?.comment,
          };
        }
        return null;
      }).filter(item => item !== null);

      setDept(params);
    } else {
      setDept([]);
    }
  }, [loadsList]);

  useEffect(() => {
    getLoads();
    getSingleCarrier();
  }, [dispatch]);

  useEffect(() => {
    if (success && selectedId) {
      const fromSearch = !!loadId;
      getLoads('noLoad', fromSearch);
      getSingleCarrier('noLoad');
      setSelectedId(null);
    }
  }, [success]);
  const handleChange = (value, name, item, index) => {
    const params = [
      ...dept,
    ];
    params[index][name] = value;
    setDept(params);

    if (name === 'reserveAmount' && error === 'reserveAmount') {
      setError('');
    }
  };

  const handleCollect = (item) => {
    setSelectedId(item?.loadId);
    if (item?.reserveAmount) {
      dispatch(collectionActions.collectLoad(carrier?.id, {
        'load': item?.loadId,
        'amount': item?.reserveAmount,
        'description': item?.comment,
      }));
    } else {
      setError('reserveAmount');
    }
  };

  const handleSearch = () => {
    if (loadId) {
      setSaveId(loadId);
      getLoads('', true);
    } else {
      ref?.current?.focus();
    }
  };

  if (carrierLoad?.length) {
    return (
      <div className="collect-loads-modal" style={{height: 535}}>
        <Loader />
      </div>
    );
  }

  return (
    <div className="collect-loads-modal">
      <p className="collect-modal-title">Collect Loads</p>

      <div className="flex-align-start" style={{ gap: 16 }}>
        <CollectRow title="Company:" value={carrier?.companyName ? carrier?.companyName : '...'} />
        <CollectRow title="Total Debt:" value={carrier?.outstandingDebt ? carrier?.outstandingDebt : 0} type={'price'} />
      </div>

      <form onSubmit={handleSubmit(handleSearch)}>
        <div className={classes.searchInputWrapper} style={{ width: '100%', margin: '16px 0 8px' }}>
          <input
            style={{ width: '100%', color: '#2A374E' }}
            ref={ref}
            type="search"
            onChange={(e) => {
              if (e?.target?.value === '' && saveId) {
                setSaveId('');
                setLoadId('');
                getLoads();
              } else {
                setLoadId(e?.target?.value);
              }
            }}
            placeholder={'Search by Load ID'}
            value={loadId}
          />
          <button onClick={handleSearch}>
            <img src={Images.searchIcon} alt={'icon'} />
          </button>
        </div>
      </form>

        <div className="collect-loads-table">
          <div className="collect-loads-table-head">
            <div style={{ width: '15%' }}>Load ID</div>
            <div style={{ width: '15%' }}>Available</div>
            <div style={{ width: '28%' }}>Amount to Collect</div>
            <div style={{ width: '30%' }}>Description</div>
            <div style={{ width: '12%' }} />
          </div>
          <div className="collect-loads-table-body">
            {loadList?.length ?
              <Loader height={'200px'} />
              :
              dept?.length ?
                dept?.map((i, j) => (
                  <div key={j} className="collect-loads-table-body-row">
                    <div className="collect-loads-table-body-item" style={{ width: '15%' }}>
                      <TextRow name={i?.loadDisplayId} />
                    </div>
                    <div className="collect-loads-table-body-item" style={{ width: '15%' }}>
                      {i?.amount % 1 !== 0 ? (
                        <p>${Math.floor(i?.amount * 1000) / 1000}</p>
                      ) : (
                        <PriceRow info={i?.amount || 0} />
                      )}
                    </div>
                    <div style={{ width: '28%' }}>
                      <CustomNumericFormat
                        noError={true}
                        errorName={selectedId === i?.loadId && error}
                        error={error === 'reserveAmount' && selectedId === i?.loadId && ErrorText.field}
                        label={'Amount*'}
                        placeholder={'Enter Amount'}
                        name={'reserveAmount'}
                        value={i?.reserveAmount ? i?.reserveAmount : 0}
                        handleChangeMiles={(e) => handleChange(e?.floatValue, 'reserveAmount', i, j)}
                        isAllowed={(values) => {
                          const { floatValue } = values;
                          const isValid = floatValue === undefined || (floatValue <= i?.amount);

                          if (!isValid && floatValue !== undefined) {
                            toast.dismiss();
                            toast(
                              <ToastScreen
                                type={'error'}
                                text={'Entered amount must be less than or equal to the available amount.'}
                              />,
                            );
                          }
                          return isValid;
                        }}
                      />
                    </div>
                    <div style={{ width: '30%' }}>
                      <ValidationInput
                        noErrMessage={true}
                        style={globalStyles.simpleInputNoRight}
                        variant={'outlined'}
                        name={'comment'}
                        type={'text'}
                        placeholder={'Write here...'}
                        onChange={(e) => handleChange(e?.target?.value, 'comment', i, j)}
                        value={i?.comment}
                      />
                    </div>
                    <div style={{ width: '12%' }}>
                      <button
                        onClick={() => handleCollect(i)}
                        className="collect-load-btn"
                      >
                        {selectedId === i?.loadId && loader?.length ?
                          <MinLoader margin={'0'} color={'white'} position={'relative'} />
                          :
                          'Collect'
                        }
                      </button>
                    </div>
                  </div>
                ))
                :
                <NoYet position={'center'} text={'Not Yet'} />
            }
          </div>
        </div>

      {/*<div className="flex-end">*/}
      {/*  <div style={{ maxWidth: 500, margin: '16px 0' }}>*/}
        {/*    <CollectRow title="Total Collection Amount:" value={500} />*/}
        {/*  </div>*/}
        {/*</div>*/}
        <AddModalButton
          loading={loader}
          handleClick={() => close()}
          text={'Done'}
        />
    </div>
);
};
